// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2wDh9","errorLogs":"EditorFooter_errorLogs__3iZfr"};